import 'css-chunksrc/client/scenes/listRemoval/styles.scss';export default {
  "header": "_header_128k4_1",
  "message": "_message_128k4_5",
  "group": "_group_128k4_12",
  "text": "_text_128k4_16",
  "count": "_count_128k4_21",
  "main": "_main_128k4_27",
  "buttons": "_buttons_128k4_36"
};